/// NodePaletteItems: Categorized Node element definitions for the palette.
/// Seven categories: Math, String, Logic, Data, Flow, HTTP, Transform.

import type { PaletteCategory } from "./BPMNPaletteItems";

// ---------------------------------------------------------------------------
// Node palette categories
// ---------------------------------------------------------------------------

export const nodePaletteCategories: PaletteCategory[] = [
  {
    name: "Math",
    color: "blue",
    items: [
      { type: "math.add", label: "Add", icon: "plus" },
      { type: "math.subtract", label: "Subtract", icon: "minus" },
      { type: "math.multiply", label: "Multiply", icon: "x" },
      { type: "math.divide", label: "Divide", icon: "divide" },
      { type: "math.modulo", label: "Modulo", icon: "percent" },
      { type: "math.abs", label: "Absolute", icon: "hash" },
      { type: "math.round", label: "Round", icon: "circle" },
      { type: "math.random", label: "Random", icon: "dice-1" },
    ],
  },
  {
    name: "String",
    color: "purple",
    items: [
      { type: "string.concat", label: "Concat", icon: "text-cursor-input" },
      { type: "string.split", label: "Split", icon: "scissors" },
      { type: "string.replace", label: "Replace", icon: "replace" },
      { type: "string.trim", label: "Trim", icon: "align-left" },
      { type: "string.length", label: "Length", icon: "ruler" },
      { type: "string.template", label: "Template", icon: "file-text" },
    ],
  },
  {
    name: "Logic",
    color: "orange",
    items: [
      { type: "logic.if", label: "If", icon: "git-branch" },
      { type: "logic.switch", label: "Switch", icon: "git-merge" },
      { type: "logic.compare", label: "Compare", icon: "scale" },
      { type: "logic.and", label: "AND", icon: "circle-dot" },
      { type: "logic.or", label: "OR", icon: "circle" },
      { type: "logic.not", label: "NOT", icon: "ban" },
    ],
  },
  {
    name: "Data",
    color: "green",
    items: [
      { type: "data.variable", label: "Variable", icon: "variable" },
      { type: "data.constant", label: "Constant", icon: "lock" },
      { type: "data.jsonParse", label: "JSON Parse", icon: "braces" },
      { type: "data.jsonStringify", label: "JSON Stringify", icon: "file-json" },
      { type: "data.objectGet", label: "Object Get", icon: "key" },
      { type: "data.objectSet", label: "Object Set", icon: "pen-line" },
    ],
  },
  {
    name: "Flow",
    color: "amber",
    items: [
      { type: "flow.start", label: "Start", icon: "play" },
      { type: "flow.end", label: "End", icon: "square" },
      { type: "flow.merge", label: "Merge", icon: "git-merge" },
      { type: "flow.fork", label: "Fork", icon: "git-fork" },
      { type: "flow.delay", label: "Delay", icon: "timer" },
      { type: "flow.loop", label: "Loop", icon: "repeat" },
    ],
  },
  {
    name: "HTTP",
    color: "red",
    items: [
      { type: "http.request", label: "HTTP Request", icon: "globe" },
      { type: "http.response", label: "HTTP Response", icon: "arrow-down" },
      { type: "http.header", label: "HTTP Header", icon: "list" },
    ],
  },
  {
    name: "Transform",
    color: "cyan",
    items: [
      { type: "transform.map", label: "Map", icon: "iterate" },
      { type: "transform.filter", label: "Filter", icon: "filter" },
      { type: "transform.reduce", label: "Reduce", icon: "minimize" },
      { type: "transform.sort", label: "Sort", icon: "arrow-up-down" },
      { type: "transform.flatten", label: "Flatten", icon: "layers" },
    ],
  },
];
